import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getDealer, saveDealer, deleteDealer } from './actions'
import App from '../common/app'
import Dealer from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="cart" {...getState()} {...appActions}>
      <Dealer
        {...getState().dealer}
        deleteDealer={deleteDealer}
        saveDealer={saveDealer}
      />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getDealer(context.params.dealerId)
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
